import { IContentBlockValuePropProps, IFeature } from "@proj-common/types"
import { Accordion } from "@proj-client/components/landing/accordion"
import React from "react"
import featureOneTouchVideo from "@proj-client/assets/vids/feature-onetouch.mp4"
import featureOneTouchPoster from "@proj-client/assets/imgs/landing/feature-onetouch.png"
import PlanGenerationPoster from "@proj-client/assets/imgs/landing/feature-plangeneration.png"
import PlanGenerationVideo from "@proj-client/assets/vids/feature-plangeneration.mp4"
import { getDefaultPlanLookupKey } from "../generic/plans"
import { FeatureCard } from "./feature-card"

const featureList: IFeature[] = [
    {
        iconEl: <i className="fa-regular fa-play-circle"></i>,
        title: "Workshop planner",
        content: "A range of built-in workshop templates from Simple Brainstorming to complex Process Improvement Workshops (pain-points, opportunites and solutions).",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
    },
    {
        iconEl: <i className="fa-regular fa-face-smile"></i>,
        title: "One touch participant experience",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
        content:
            "Every screen has one purpose and one possible action. This saves you the time to onboard your team to a new tool and the frustration of fumbling aroudn on an infinite canvas.",
    },
    {
        iconEl: <i className="fa-regular fa-hand-point-right"></i>,
        title: "Automatic event facilitation",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
        content:
            "Workshop intructions are always visible and right in front of you and your team. No need to reiterate to everyone the instructions."
    },
    {
        iconEl: <i className="fa-regular fa-file-powerpoint"></i>,
        title: "Instant export, including PowerPoint",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
        content:
            "No need to spend endless hours copy pasting stickies and compiling them into a PowerPoint presentation. Just click the Export button and you're done.",
    },
    {
        iconEl: <i className="fa-regular fa-file-powerpoint"></i>,
        title: "Easy to track progress",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
        content:
            "",
    },
    {
        iconEl: <i className="fa-regular fa-file-powerpoint"></i>,
        title: "Built for mobile and big screens",
        videoPath: PlanGenerationVideo,
        posterPath: PlanGenerationPoster,
        content:
            "",
    },
    // {
    //     id: 'f05',
    //     iconEl: <i className="fa-regular fa-note-sticky"></i>,
    //     title: "Miro, Mural and FigJam export",
    //     content:
    //         "Once you have the top ideas, you can export them to Miro, Mural and Figma Jam to turn them into full-blown concepts.",
    // },
    // {
    //     id: 'f06',
    //     iconEl: <i className="fa-regular fa-file-excel"></i>,
    //     title: "Google Sheets and Excel export",
    //     content:
    //         "No need to spend endless hours copy pasting stickies and compiling them into an Excel presentation. Just click the Export button and you're done."
    // }
]

const cardColors = [
    'bg-violet-300', 'bg-purple-300', 'bg-fuchsia-300', 'bg-pink-300', 'bg-rose-300', 'bg-orange-300', 'bg-amber-300', 'bg-yellow-300',
    'bg-lime-300', 'bg-green-300', 'bg-emerald-300', 'bg-teal-300', 'bg-cyan-300', 'bg-sky-300', 'bg-blue-300', 'bg-indigo-300'
]


export const ContentFeatures = (props: IContentBlockValuePropProps) => {

    return (<div className="bg-slate-800 text-white pl-4 pr-4 pt-8 pb-8">
        <div className="flex flex-col items-center">
            <div className="flex flex-row justify-center flex-1 p-2">
                <h1 className="text-2xl text-center font-bold md:text-6xl font-display leading-snug py-4 md:py-10">
                    Let's take the work out of workshops!
                </h1>
            </div>
            {/* <div className="mt-4 md:hidden">
                {featureList.map((item, index) => (
                    <Accordion key={index} title={item.title} content={item.content} iconEl={item.iconEl} />
                ))}
            </div> */}
            <div className="gap-12 grid container m-auto grid-cols-1 lg:grid-cols-2 md:pt-4 md:pb-4 " >

                {featureList.map((item, index) => (
                    <FeatureCard
                        title={item.title}
                        videoPath={item.videoPath}
                        posterPath={item.posterPath}
                        key={index}
                        bgColor={cardColors[index]}
                    />
                ))}
            </div>
            <a
                //href="/register"
                onClick={() => {props.ctaHandler && props.ctaHandler(getDefaultPlanLookupKey())}}
                //target='_blank'
                // TODO: uncomment href="/new"
                //TODO: onClick={this.props.ctaHandler && this.props.ctaHandler()}
                className="mt-8 mb-8 umami--click--get-started idtn-btn-primary-xl place-self-center"
                aria-label={props.ctaText}
            >
                {props.ctaText}
            </a>
        </div>
    </div>)
}